import {
  DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_BEGIN,
  DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_SUCCESS,
  DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_FAILURE,
  DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function getMySqlTableSchema(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_BEGIN,
    });
    const { version, projectId, dbUuid, name: tableName } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/externalDb/${dbUuid}/ddl/${tableName}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed to get the table schema.`, {});
          console.error('Failed:', errMsg);
          dispatch({
            type: DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetMySqlTableSchemaError() {
  return {
    type: DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getMySqlTableSchemaPending: true,
        getMySqlTableSchemaError: null,
      };

    case DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_SUCCESS:
      // The request is success
      return {
        ...state,
        getMySqlTableSchemaPending: false,
        getMySqlTableSchemaError: null,
        mysqlTableSchema: action.data,
      };

    case DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_FAILURE:
      // The request is failed
      return {
        ...state,
        getMySqlTableSchemaPending: false,
        getMySqlTableSchemaError: action.data.error,
      };

    case DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getMySqlTableSchemaError: null,
      };

    default:
      return state;
  }
}
